export default "__VITE_ASSET__CeCb42vH__"